import React from 'react';

export const CorporateHeroSection = ({ isPortuguese, onOpenBooking, onViewServices, onOpenContact }) => {
  return (
    <section id="home" className="pt-24 pb-12 sm:pt-32 sm:pb-20 bg-gradient-to-br from-blue-50 to-blue-100" data-testid="home-hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-block bg-blue-600 text-white px-4 py-2 rounded-full text-sm sm:text-base font-semibold mb-4" data-testid="home-hero-badge">
          {isPortuguese ? 'Atendimento premium no Japão' : 'Premium support in Japan'}
        </div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6" data-testid="home-hero-title">
          {isPortuguese ? 'Soluções premium para crédito, imóveis e planejamento' : 'Premium solutions for credit, real estate and planning'}
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-700 mb-6 sm:mb-8 max-w-3xl mx-auto" data-testid="home-hero-subtitle">
          {isPortuguese
            ? 'Uma presença mais forte, elegante e memorável para sua marca e seus serviços.'
            : 'A stronger, elegant and memorable presence for your brand and services.'}
        </p>
        <p className="text-base sm:text-lg text-gray-600 mb-8 sm:mb-10 max-w-2xl mx-auto" data-testid="home-hero-description">
          {isPortuguese
            ? 'Crédito auto, imóveis, reforma, painel solar e tecnologia PropTech apresentados com alto valor percebido sem perder a base funcional que já está pronta.'
            : 'Auto credit, real estate, renovation, solar and PropTech technology presented with higher perceived value while preserving the working platform underneath.'}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-testid="home-hero-primary-actions">
          <button
            onClick={onOpenBooking}
            className="bg-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-green-700 transition transform hover:scale-105 flex items-center justify-center gap-2"
            data-testid="home-hero-booking-button"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {isPortuguese ? 'Quero atendimento' : 'Book service'}
          </button>
          <button
            onClick={onViewServices}
            className="bg-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-blue-700 transition transform hover:scale-105"
            data-testid="home-hero-services-button"
          >
            {isPortuguese ? 'Ver soluções' : 'See solutions'}
          </button>
          <button
            onClick={onOpenContact}
            className="bg-white text-blue-600 border-2 border-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-blue-50 transition transform hover:scale-105"
            data-testid="home-hero-contact-button"
          >
            {isPortuguese ? 'Falar com especialista' : 'Talk to a specialist'}
          </button>
        </div>

        <div className="mt-8 sm:mt-12" data-testid="home-hero-floorplan-cta">
          <a
            href="/desenhar-planta"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl text-lg sm:text-xl font-bold hover:from-purple-700 hover:to-indigo-700 transition transform hover:scale-105 shadow-xl shadow-purple-500/30 animate-pulse"
            data-testid="home-draw-plan-link"
          >
            <span className="text-3xl">🏗️</span>
            <div className="text-left">
              <div>{isPortuguese ? 'Faça o desenho da sua reforma aqui!' : 'Draw your renovation plan here!'}</div>
              <div className="text-sm font-normal text-purple-200">{isPortuguese ? 'Editor 3D gratuito • Receba orçamento' : 'Free 3D Editor • Get a quote'}</div>
            </div>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center" data-testid="home-hero-shortcuts">
          <a
            href="/questionario-casas"
            className="inline-flex items-center gap-3 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition transform hover:scale-105"
            data-testid="home-questionario-casas-link"
          >
            <span className="text-2xl">🏠</span>
            <span>{isPortuguese ? 'Procurando Casa?' : 'Looking for a House?'}</span>
          </a>
          <a
            href="/questionario-carros"
            className="inline-flex items-center gap-3 bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition transform hover:scale-105"
            data-testid="home-questionario-carros-link"
          >
            <span className="text-2xl">🚗</span>
            <span>{isPortuguese ? 'Procurando Carro?' : 'Looking for a Car?'}</span>
          </a>
        </div>
      </div>
    </section>
  );
};
